import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Channel } from '../../types';

interface ChannelsState {
  list: Channel[];
  loading: boolean;
  error: string | null;
}

const initialState: ChannelsState = {
  list: [],
  loading: false,
  error: null,
};

const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setChannels: (state, action: PayloadAction<Channel[]>) => {
      state.list = action.payload;
      state.loading = false;
    },
    addChannel: (state, action: PayloadAction<Channel>) => {
      state.list.push(action.payload);
    },
    updateChannel: (state, action: PayloadAction<Channel>) => {
      const index = state.list.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
    deleteChannel: (state, action: PayloadAction<string>) => {
      state.list = state.list.filter(c => c.id !== action.payload);
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setLoading, 
  setChannels, 
  addChannel, 
  updateChannel, 
  deleteChannel, 
  setError 
} = channelsSlice.actions;
export default channelsSlice.reducer; 